import { createSvgIcon } from '@mui/material/utils';

export const BarcodeIcon = createSvgIcon(
  <path d="M1 19V5H3V19H1ZM4 19V5H6V19H4ZM7 19V5H8V19H7ZM10 19V5H12V19H10ZM13 19V5H16V19H13ZM17 19V5H18V19H17ZM20 19V5H23V19H20Z" />,
  'Barcode',
);
